import type { SvgIconProps } from '@village/icons';
import { SvgIcon } from '@village/icons';
import { forwardRef } from 'react';

export const CheckboxUncheckedIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
    <SvgIcon ref={ref} data-testid="checkbox-unchecked-icon" {...props}>
        <path d="M1 1H19V19H1V1Z" stroke="#868787" strokeWidth="2" />
    </SvgIcon>
));
